export default __webpack_public_path__ + "static/media/home-services.4cc5f0f3.jpg";